import { Inject } from '@odinjs/odin';
import {ContextType, DataContext}from '@philips-internal/oswald-ui-core/lib/component/context';

import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';

class BaseControllerExams {

  historyService = HistoryService;

  @Inject(ContextType.DATA)
    context!: DataContext;

}

export default BaseControllerExams;